import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import 'matchmedia-polyfill'

import { SoundEffectsProvider, AlertProvider } from '@astrid/components'

import RouterStackComponent from 'routes/RouterStackComponent'
import initStore from './store'
import AchievementHandler from 'components/AchievementHandler/AchievementHandler'

import './App.scss'

const firebaseConfig = {
  apiKey: 'AIzaSyDIKTbG4zEBwn-qCXxm7-zQdpZaSfEB8n8',
  authDomain: 'astrid-infra.firebaseapp.com',
  databaseURL: 'https://astrid-infra-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'astrid-infra',
  storageBucket: 'astrid-infra.firebasestorage.app',
  messagingSenderId: '195291200637',
  appId: '1:195291200637:web:e0ef682009c3e8aa1c4514',
  measurementId: 'G-CP7LRDR02X'
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)

export default function App() {
  const store = initStore()

  return (
    <ReduxProvider store={store}>
      <SoundEffectsProvider>
        <AlertProvider>
          <div className="app">
            <RouterStackComponent />
            <AchievementHandler />
          </div>
          <div id="draggable" />
        </AlertProvider>
      </SoundEffectsProvider>
    </ReduxProvider>
  )
}
